import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router/";
import store from "./store/store";
import "./registerServiceWorker";
import "font-awesome/css/font-awesome.css";
import VueAxios from "vue-axios";
import axios from "axios";
import VueCookies from "vue-cookies";
import ImageUploader from "vue-image-upload-resize";
import VueAnalytics from "vue-analytics";
import coverflow from "vue-coverflow";
import VueAwesomeSwiper from "vue-awesome-swiper";
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import VSwipe from 'vswipe'

//Layout components
import Default from './components/layouts/Default.vue';
import NoSidebar from './components/layouts/NoSidebar.vue';

Vue.component('default-layout', Default);
Vue.component('no-sidebar-layout', NoSidebar);

Vue.use(wysiwyg, {
  maxHeight: "50px"
});
var SocialSharing = require("vue-social-sharing");
import "swiper/dist/css/swiper.css";

var filter = function(text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter("truncate", filter);

//Vue Swipe
Vue.use(VSwipe)


Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(coverflow);
Vue.use(SocialSharing);
Vue.use(ImageUploader);
Vue.use(VueAnalytics, {
  id: "UA-139455048-1",
  router
});
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.use(VueCookies);
Vue.use(VueAxios, axios);

//ionicons
import AllMdIcon from 'vue-ionicons/dist/ionicons-md.js'
require('vue-ionicons/ionicons.css')
Vue.use(AllMdIcon)

//Jquery
window.$ = window.jQuery = require('jquery');

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    store.dispatch('SET_LOADER', true);
    const token = window.$cookies.get("token");
    const business_info = window.$cookies.get("business_info");
    
    if (to.meta.public === true) {
        next();
    }
    if (to.meta.public === true && to.meta.loggedin === true && !token) {
        next('/login');
    }
    if (to.meta.public === true && business_info === false) {
        next('/business-details');
    }
    if (to.path !== '/login' && to.meta.public === undefined) {
        if (!token) {
          next('/login');
        }
    }
    if (to.path === '/register' && to.meta.public === undefined) {
        if (!token) {
          next('/register');
        }
    }
    if (to.path === '/login') {
        if (token) {
          next('/product-dashboard');
        }
    }
    
    if (to.path === '/register') {
        if (token) {
          next('/product-dashboard');
        }
    }
    next()
})


router.afterEach((to, from) => {
  //setTimeout(() => store.dispatch('SET_LOADER', false), 1500) // timeout for demo purposes
    store.dispatch('SET_LOADER', false)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
